export default "__VITE_ASSET__BiH__zdH__"